import { render, staticRenderFns } from "./revisarDocumentosModal.vue?vue&type=template&id=1deda113"
import script from "./revisarDocumentosModal.vue?vue&type=script&lang=js"
export * from "./revisarDocumentosModal.vue?vue&type=script&lang=js"
import style0 from "./revisarDocumentosModal.vue?vue&type=style&index=0&id=1deda113&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports